import React from 'react';
import styled from 'styled-components';
import Button from '@catalogo/ui-americanas-desktop-button';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
`;

const Title = styled.p`
  flex: 1;
  color: ${({ theme }) => theme.grey.dark};
  font-size: 18px;
  color: #666;
`;

const Message = styled.p`
  flex: 1;
  font-weight: 600;
  font-size: 20px;
`;

const WrapperButton = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;

const ButtonUI = styled(Button)`
  border: 2px solid ${({ theme }) => theme.primaryColor};
  color: ${({ theme }) => theme.primaryColor};
  text-transform: ${({ theme }) => theme.btnTextTransform};
  font-weight: ${({ theme }) => theme.btnTextWeigth};
  cursor: pointer;

  & :hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export const HasNoQuestions = ({ titleNoQuestions, productId, hasCustomerQuestions, hasOffers }) => (
  <Wrapper>
    <div>
      <Title>Este produto ainda não tem perguntas.</Title>
      {!hasCustomerQuestions && hasOffers && <Message>{titleNoQuestions}</Message>}
    </div>
    {hasOffers && (
      <WrapperButton>
        <ButtonUI
          href={`/perguntar/${productId}`}
          width="200px"
          height="45px"
          title="Escrever pergunta"
          borderRadius="8px"
          fontSize="16px"
        />
      </WrapperButton>
    )}
  </Wrapper>
);
